
export default class GlobalData {
    esList: {[key: string]: any} = {};
    __uniqueId = 1;

    setESList(esList: any[]){
        esList.forEach(es => { this.esList[es.name] = es; });
    }

    uniqueId(){
        return this.__uniqueId++;
    }

}

export const Data = new GlobalData();